module.exports = __webpack_public_path__ + "assets/images/tutorial6.8b2e5c3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial6.png
// module id = 457
// module chunks = 1